import { render, staticRenderFns } from "./addEditblog.vue?vue&type=template&id=44bb2266&scoped=true&"
import script from "./addEditblog.vue?vue&type=script&lang=js&"
export * from "./addEditblog.vue?vue&type=script&lang=js&"
import style0 from "./addEditblog.vue?vue&type=style&index=0&id=44bb2266&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb2266",
  null
  
)

export default component.exports